import {makeStyles} from "@material-ui/core";
import {moveNextPage, updateCreatorOnboarding} from "../../../../../store/actions/creator/creatorOnBoarding";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import UtilService from "../../../../../helper/service";
import {useHistory, useLocation} from "react-router";
import OnboardingBtn from "../../../../atoms/creator/onboardingEnterBtn";

const useStyles = makeStyles(() => ({
  title: {
    margin: '10px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& p': {
      margin: 0,
      fontSize: (props: any) => (props.width < 1200 || props.height < 770) ? 30 : 36,
      color: '#212D40',
      fontFamily: 'Spartan-bold',
      lineHeight: 1.25,
      maxWidth: 900,
      textAlign: 'center',
      '@media (max-width: 600px)': {
        fontSize: '25px!important',
      },
    },
  },
  description: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 25,
    marginBottom: -30,
    '& p': {
      margin: 0,
      fontFamily: 'roboto-light',
      fontSize: (props: any) => (props.width < 1200 || props.height < 770) ? 20 : 24,
      color: '#212D40',
      lineHeight: 1.25,
      maxWidth: 850,
      textAlign: 'center',
      '@media (max-width: 600px)': {
        fontSize: '15px!important',
      },
    },
  },
  imgDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 600px)': {
      width: 400,
      height: 200
    },
    '@media (max-width: 400px)': {
      width: 320,
      height: 180
    },
  },
  img: {
    width: (props: any) => props.height < 780 ? 600 : 800,
    height: 'auto',
    '@media (max-width: 600px)': {
      width: 400,
      height: 200
    },
    '@media (max-width: 400px)': {
      width: 320,
      height: 180
    },
  }
}));

const Module1Slide3 = () => {

  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { activepage } = userPreferences;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm1s3');
  }, []);

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13) {
      goNext();
    }
  };

  const goNext = () => {
    const request = {
      user_id: loginUserData.user_id,
      preference_id: userPreferences.module1s3.id,
      preference_name: 'MODULE1S3',
      preference_information: 'true',
    };
    dispatch(updateCreatorOnboarding(apolloClient.client, request));

    if (Number(activepage.value) < 5) {
      const reqActivePage = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activepage.id,
        preference_name: 'ACTIVEPAGE',
        preference_information: '5',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));
    }

    dispatch(moveNextPage(5))
  };

  const goBack = () => {
    dispatch(moveNextPage(3))
  };

  return (
    <div>
      <div className={classes.title}>
        <p>
          Immersion is designed to make the complex science easy to understand and take action on.
        </p>
      </div>

      <div className={classes.imgDiv}>
        <img className={classes.img} src={'/assets/icons/onboarding/module1-slide3.gif'} alt={'Overview Tab Scrolling'}/>
      </div>

      <div className={classes.description}>
        <p>
          For every measurement, we give you an overall Immersion Score from 1-100. 
          We also show you the most important moments, and tell you about your audience.
        </p>
      </div>
      <OnboardingBtn goNext={goNext} goBack={goBack} title={'Got It'} isRight/>
    </div>
  )
};

export default Module1Slide3;